export default __webpack_public_path__ + "static/media/narrow.926bbebb.webp";